import { ReportData, ReportData$Material, Review, Comment, Milestone, Report } from "@/interfaces/report";

export class DashboadData {
    // クラスのメソッド(関数)に型宣言
    public getReportData(): ReportData {
        let date = new Date();
        let review: Review = {
            score: 0
        };
        let comment: Comment = {
            comment: "",
            timestamp: date
        }
        let reportDataMaterial: ReportData$Material = {
            fileName: "",
            uploadedAt: date,
            comment: comment
        };
        let milestone: Milestone = {
            prepare: {
                date: date,
                items: []
            },
            doing: {
                date: date,
                items: []
            },
            payment: {
                startDate: date,
                endDate: date
            }
        };
        const reportData: ReportData = {
            // 残預金
            accountBalance: '12345678',
            // 残預金
            monthlyIncome: '1000',
            // 残預金
            monthlyExpense: '未提出',
            // 希望調達額
            expectFinanceAmount: 500000000,
            // 希望調達日
            expectFinanceDate: new Date('2022-10-31'),
            // スコアリング（値は5以下の値）
            reviews: {
                debt: {
                    overall_score: 'D',
                    // 株主資本比率
                    equityRatio: {
                        score: 4,
                        comment: {
                            comment: "equityRatioテスト",
                            timestamp: date
                        },
                    },
                    // 流動比率
                    currentRatio: {
                        score: 2.5,
                        comment: {
                            comment: "currentRatioテスト",
                            timestamp: date
                        },
                    },
                    // 当座比率
                    quickRatio: {
                        score: 3.8,
                        comment: {
                            comment: "quickRatioテスト",
                            timestamp: date
                        },
                    },
                    // 固定比率
                    fixedRatio: {
                        score: 4,
                        comment: {
                            comment: "fixedRatioテスト",
                            timestamp: date
                        },
                    },
                    // インスタント・カバレッジ・レシオ
                    instantCoverageRatio: {
                        score: 1,
                        comment: {
                            comment: "instantCoverageRatioテスト",
                            timestamp: date
                        },
                    },
                    // 総評
                    overallReviews: [
                        {
                            comment: "ソフトウェア仮勘定を多く計上しているため、流動比率が良く、当座比率が低い状態となっています。現状借入を行なっているものの、リスケ状態となっていることから、追加の金融機関の借入は難しい印象を受けます",
                            timestamp: date
                        },
                        {
                            comment: "2021年度の売上は4000万となっているため、約1,000-1,200万程度の借入が見込める可能性があります",
                            timestamp: date
                        },
                    ],
                },
                equity: {
                    overall_score: 'C',
                    // プロダクト
                    product: {
                        score: 3,
                        comment: {
                            comment: "productテスト",
                            timestamp: date
                        },
                    },
                    // 顧客解像度
                    understandingCustomer: {
                        score: 2.6,
                        comment: {
                            comment: "understandingCustomerテスト",
                            timestamp: date
                        },
                    },
                    // 市場規模
                    marketSize: {
                        score: 5,
                        comment: {
                            comment: "marketSizeテスト",
                            timestamp: date
                        },
                    },
                    // 実績・トラクション
                    traction: {
                        score: 1,
                        comment: {
                            comment: "tractionテスト",
                            timestamp: date
                        },
                    },
                    // チーム
                    team: {
                        score: 4,
                        comment: {
                            comment: "teamテスト",
                            timestamp: date
                        },
                    },
                    // 総評
                    overallReviews: [
                        {
                            comment: "現状の希望Valは、事業進捗に比べて高い印象を受けます。スライド、もしくはダウンラウンドを視野に入れつつ、シリーズA調達に向けて必要な達成条件の整理が必要と感じます",
                            timestamp: date
                        },
                        {
                            comment: "具体的なターゲットペルソナ、課題に基づく機能、価値提供を検討した上で、Cのエンゲージメント向上、購買意思（WTP）の向上を目指してはいかがでしょうか",
                            timestamp: date
                        },
                    ],
                },
                subsidy: [{
                    // 名称
                    name: "令和4年度TOKYOイノベーション促進事業",
                    // リンク先URL
                    linkUrl: "https://portal.monodukuri-hojo.jp/",
                    // 申請期間
                    applicationPeriod: {
                        from: date,
                        to: date,
                    },
                    // 金額
                    amount: 30000000,
                    // 提供機関
                    managedBy: "公益財団法人東京都中小企業復興公社",
                },
                {
                    // 名称
                    name: "令和4年度TOKYOイノベーション促進事業",
                    // リンク先URL
                    linkUrl: "https://portal.monodukuri-hojo.jp/",
                    // 申請期間
                    applicationPeriod: {
                        from: date,
                        to: date,
                    },
                    // 金額
                    amount: 30000000,
                    // 提供機関
                    managedBy: "公益財団法人東京都中小企業復興公社",
                },
                {
                    // 名称
                    name: "令和4年度TOKYOイノベーション促進事業",
                    // リンク先URL
                    linkUrl: "https://portal.monodukuri-hojo.jp/",
                    // 申請期間
                    applicationPeriod: {
                        from: date,
                        to: date,
                    },
                    // 金額
                    amount: 30000000,
                    // 提供機関
                    managedBy: "公益財団法人東京都中小企業復興公社",
                }
                ]
            },
            // 推奨調達手法(Pie Chart)
            recommendedFinanceDetails: {
                debt: {
                    amount: 30000000
                },
                equity: {
                    amount: 20000000
                },
                subsidy: {
                    amount: 10000000
                }
            },
            // 資金調達のマイルストーン
            milestones: {
                debt: {
                    prepare: {
                        date: new Date("2022-8-20"),
                        items: [{
                            title: "事前相談",
                            date: new Date("2022-9-2"),
                            kind: 'prepare',
                            comment: {
                                comment: "コメントが入ります",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "提出書類準備",
                            date: new Date("2022-9-6"),
                            kind: 'prepare',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },]
                    },
                    doing: {
                        date: new Date("2022-10-21"),
                        items: [{
                            title: "融資条件面談・書類提出",
                            date: new Date("2022-10-4"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "保証協会・金融機関審査",
                            date: new Date("2022-10-15"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "書類結果通知",
                            date: new Date("2022-11-8"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },]
                    },
                    payment: {
                        startDate: new Date("2022-12-20"),
                        endDate: new Date("2022-1-5"),
                    }
                },
                equity: {
                    prepare: {
                        date: new Date("2022-8-28"),
                        items: [{
                            title: "事前相談",
                            date: new Date("2022-9-2"),
                            kind: 'prepare',
                            comment: {
                                comment: "コメントが入ります",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "提出書類準備",
                            date: new Date("2022-9-6"),
                            kind: 'prepare',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },]
                    },
                    doing: {
                        date: new Date("2022-9-31"),
                        items: [{
                            title: "融資条件面談・書類提出",
                            date: new Date("2022-10-4"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "保証協会・金融機関審査",
                            date: new Date("2022-10-15"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "書類結果通知",
                            date: new Date("2022-11-8"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },]
                    },
                    payment: {
                        startDate: new Date("2022-12-20"),
                        endDate: new Date("2022-1-5"),
                    }
                },
                subsidy: {
                    prepare: {
                        date: new Date("2022-8-28"),
                        items: [{
                            title: "事前相談",
                            date: new Date("2022-9-2"),
                            kind: 'prepare',
                            comment: {
                                comment: "コメントが入ります",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "提出書類準備",
                            date: new Date("2022-9-6"),
                            kind: 'prepare',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },]
                    },
                    doing: {
                        date: new Date("2022-9-31"),
                        items: [{
                            title: "融資条件面談・書類提出",
                            date: new Date("2022-10-4"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "保証協会・金融機関審査",
                            date: new Date("2022-10-15"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },
                        {
                            title: "書類結果通知",
                            date: new Date("2022-11-8"),
                            kind: 'doing',
                            comment: {
                                comment: "コメントが入ります。コメントが入ります。コメントが入ります。",
                                timestamp: new Date()
                            }
                        },]
                    },
                    payment: {
                        startDate: new Date("2022-12-20"),
                        endDate: new Date("2022-1-5"),
                    }
                },
            },
            recommendedFinancialInstitutions: [
                {
                    name: "広島ベンチャーキャピタル",
                    targetPhases: [
                        "Early Round",
                        "Series A Round",
                        "Series B Round"
                    ],
                    thumbnailUrl: "https://drive.google.com/uc?export=view&id=1is3RBOwdtw6PU8PjLx0Lro_EjIn5BXfy",
                    expectedCriteria: [
                        "事業フェーズ",
                        "サービス・プロダクト",
                        "地域"
                    ],
                    targetIndustries: [
                        "IT、製造、バイオ、アグリ"
                    ]
                },
                {
                    name: "静岡キャピタル",
                    targetPhases: [
                        "Early Round",
                        "Series A Round",
                        "Series B Round"
                    ],
                    thumbnailUrl: "https://pbs.twimg.com/media/FdEshG3aEAEf_E2?format=jpg&name=large",
                    expectedCriteria: [
                        "事業フェーズ",
                        "サービス・プロダクト"
                    ],
                    targetIndustries: [
                        "医療・介護、環境、IoT、AI、ロボット、航空宇宙"
                    ]
                },
                {
                    name: "新潟ベンチャーキャピタル",
                    targetPhases: [
                        "Early Round",
                        "Series A Round",
                        "Series B Round"
                    ],
                    thumbnailUrl: "https://drive.google.com/uc?export=view&id=12o6evUSdRfnjZzWERJJBwFJzwxTkiDs8",
                    expectedCriteria: [
                        "事業フェーズ",
                        "サービス・プロダクト"
                    ],
                    targetIndustries: [
                        "指定なし"
                    ]
                },
                {
                    name: "ちばぎんキャピタル",
                    targetPhases: [
                        "Early Round",
                        "Series A Round",
                        "Series B Round",
                        "Series C Round"
                    ],
                    thumbnailUrl: "https://drive.google.com/uc?export=view&id=1_4BNTi_pXjdcufr-i2Dhz_ZIlUUwNRl4",
                    expectedCriteria: [
                        "事業フェーズ",
                        "サービス・プロダクト"
                    ],
                    targetIndustries: [
                        "指定なし"
                    ]
                },
                {
                    name: "ナントCVCファンド",
                    targetPhases: [
                        "Early Round",
                        "Series A Round",
                        "Series B Round"
                    ],
                    thumbnailUrl: "https://drive.google.com/uc?export=view&id=1PJNiVDatO8O3M1Imcykbwh5G1i9D8Qoa",
                    expectedCriteria: [
                        "事業フェーズ",
                        "サービス・プロダクト"
                    ],
                    targetIndustries: [
                        "指定なし"
                    ]
                },
                {
                    name: "山口フィナンシャルグループ",
                    targetPhases: [
                        "Early Round",
                        "Series A Round",
                        "Series B Round"
                    ],
                    thumbnailUrl: "https://drive.google.com/uc?export=view&id=1KCEK4O8u08wRyC3uTeb7xKIUuCfJJM1b",
                    expectedCriteria: [
                        "事業フェーズ",
                        "サービス・プロダクト"
                    ],
                    targetIndustries: [
                        "指定なし"
                    ]
                }

            ],
            relatedCompanyInformations: [
                {
                    publishedDate: new Date("2018-09-12T15:00:00.000Z"),
                    companyName: "株式会社Stroly",
                    prTimesTitle: "株式会社ABC、シリーズBで約2.5億円の資金調調達を実施",
                    amount: "約2.5億円",
                    thumbnailUrl: "https://www.yoshinoya.com/logo/assets/img/logo-oriental-2.png",
                    prTimesUrl: "https://portal.monodukuri-hojo.jp/",
                },
                {
                    publishedDate: new Date("2018-09-12T15:00:00.000Z"),
                    companyName: "株式会社Stroly",
                    prTimesTitle: "株式会社ABC、シリーズBで約2.5億円の資金調調達を実施",
                    amount: "約2.5億円",
                    thumbnailUrl: "https://www.yoshinoya.com/logo/assets/img/logo-oriental-2.png",
                    prTimesUrl: "https://portal.monodukuri-hojo.jp/",
                },
                {
                    publishedDate: new Date("2018-09-12T15:00:00.000Z"),
                    companyName: "株式会社Stroly",
                    prTimesTitle: "株式会社ABC、シリーズBで約2.5億円の資金調調達を実施",
                    amount: "約2.5億円",
                    thumbnailUrl: "https://www.yoshinoya.com/logo/assets/img/logo-oriental-2.png",
                    prTimesUrl: "https://portal.monodukuri-hojo.jp/",
                },
            ]
        }

        return reportData;
    }
    public getReports(): Report[] {
        return [{
            id: 1,
            company_id: 1,
            created_at: new Date(),
            created_by: 1,
            updated_at: new Date(),
            updated_by: 1,
            result_uploaded: true,
            result_completed_at: new Date(),
            reenter_request: false,
        },
        {
            id: 2,
            company_id: 1,
            created_at: new Date('2020-7-14'),
            created_by: 1,
            updated_at: new Date('2020-7-14'),
            updated_by: 1,
            result_uploaded: true,
            result_completed_at: new Date('2020-7-14'),
            reenter_request: true,
        }]
    }
}